export {
	SIGNSTORE_APP_BASE,
	SIGNSTORE_USER_INFO_KEY,
	SIGNSTORE_AUTH_KIND_KEY,
	SIGNSTORE_AUTH_SUB_KEY,
	isCarvueDevProxyHost
} from '@/pages/car/js/config.js'

/**
 * 车展 H5 印章规则（仅此四条，pointIndex 1–4，禁止混用）
 * | pointIndex | 规则码 | signlog.point |
 * | 1 | RULERsssFFEW1 | hexiao1 | 摇享好礼（摇一摇中奖核销）
 * | 2 | RULEEES23JB | one | 互动打卡 打卡区1
 * | 3 | RULEKKCnb37 | three | 互动打卡 打卡区2
 * | 4 | RULEffTe2oNP | gift | 拉享好礼（盖章核销）
 */
export const CAR_SHAKE_VERIFY_RULE_CODE = 'RULERsssFFEW1'

export const CAR_RULE_POINT_INDEX = {
	RULERsssFFEW1: 1,
	RULEEES23JB: 2,
	RULEKKCnb37: 3,
	RULEffTe2oNP: 4
}

export const CAR_POINT_INDEX_LEGACY = {
	1: 'hexiao1',
	2: 'one',
	3: 'three',
	4: 'gift'
}

/**
 * 盖章热区整体上移（相对活动/默认锚点 top%，负值=往上）
 * 仅影响 .log_checkin_verify_zone / .gift_checkin_verify_zone / #homeShakeVerifyZone 及打卡区指向线
 */
export const CAR_CHECKIN_ZONE_TOP_OFFSET_PCT = -10

/** 摇享好礼盖章核销区额外上移（在 CAR_CHECKIN_ZONE_TOP_OFFSET_PCT 基础上，仅 #homeShakeVerifyZone） */
export const CAR_SHAKE_UI_EXTRA_TOP_OFFSET_PCT = -11

/** 拉享好礼状态图与盖章区额外上移（在 CAR_CHECKIN_ZONE_TOP_OFFSET_PCT 基础上） */
export const CAR_GIFT_UI_EXTRA_TOP_OFFSET_PCT = -9

/** 四指盖章热区背景（测试时可改为半透明色，正式环境用 transparent） */
export const CAR_SEAL_ZONE_DEBUG_BG = 'transparent'

export const CAR_SHAKE_PASSWORD_VERIFY_CODE = '0702'
/** 互动打卡顶部密码热点：打卡区1 / 打卡区2 */
export const CAR_LOG_PASSWORD_VERIFY_CODES = {
	one: '0703',
	three: '0704'
}
/** 拉享好礼顶部密码核销 */
export const CAR_GIFT_PASSWORD_VERIFY_CODE = '0705'
/** 摇享好礼密码核销固定四指坐标（800×600 标准坐标系） */
export const CAR_SHAKE_PASSWORD_VERIFY_POINTS = [
	[564, 275],
	[267, 266],
	[412, 385],
	[253, 498]
]
/** 互动打卡密码打卡固定四指坐标 */
export const CAR_LOG_PASSWORD_VERIFY_POINTS = {
	one: [
		[331, 124],
		[511, 218],
		[177, 278],
		[213, 389]
	],
	three: [
		[517, 120],
		[607, 350],
		[406, 252],
		[262, 280]
	]
}
/** 拉享好礼密码核销固定四指坐标 */
export const CAR_GIFT_PASSWORD_VERIFY_POINTS = [
	[529, 365],
	[220, 357],
	[371, 476],
	[379, 249]
]
/** @deprecated 使用 CAR_SHAKE_PASSWORD_VERIFY_POINTS */
export const CAR_PASSWORD_VERIFY_POINTS = CAR_SHAKE_PASSWORD_VERIFY_POINTS

/** 盖章/打卡成功 Toast 停留时长（默认 3000ms 偏久） */
export const CAR_TOAST_SEAL_SUCCESS_MS = 2000

/** 摇一摇中奖提示文案 */
export const CAR_SHAKE_WIN_MESSAGE = '恭喜中奖，请至前台兑换礼品'

/** 互动打卡四指盖章区默认锚点（750×1334 百分比，对齐展台中央） */
export const CAR_LOG_CHECKIN_ZONE_DEFAULT = {
	left: 50,
	top: 54,
	sizeWidth: 600,
	sizeHeight: 600
}

/** 打卡地图相对盖章锚点额外下移（rem，与 html-rem 一致） */
export const CAR_LOG_MAP_EXTRA_DOWN_REM = 0.98

/** 打卡区标签区基础高度（rem，地图上方预留，不含上移量） */
export const CAR_LOG_CHECKIN_LABEL_ZONE_BASE_REM = 0.64

/** 打卡区标签上移量（rem；同步加长竖线，末端 icondian 位置不变） */
export const CAR_LOG_CHECKIN_LABEL_RISE_REM = 0.65

/** 打卡区标签区总高度（rem）= 基础上方区 + 上移量 */
export const CAR_LOG_CHECKIN_LABEL_ZONE_REM =
	CAR_LOG_CHECKIN_LABEL_ZONE_BASE_REM + CAR_LOG_CHECKIN_LABEL_RISE_REM

/** 打卡区1/2 整体纵向偏移（rem，正值=下移，标签/竖线/icondian 同步） */
export const CAR_LOG_CHECKIN_MARKER_SHIFT_Y_REM = 0.53

/** 打卡区竖线最小长度（rem）；动态间距不足时保底 */
export const CAR_LOG_CHECKIN_LINE_MIN_REM = 1.5

/** 打卡区1 标签/竖线水平锚点（%，相对 dakatu 图宽，translateX(-50%) 居中） */
export const CAR_LOG_CHECKIN_LABEL_ANCHOR_LEFT_PCT = 22

/** 打卡区2 标签/竖线水平锚点（%） */
export const CAR_LOG_CHECKIN_LABEL_ANCHOR_RIGHT_PCT = 80

/** 竖线基础长度（rem，自标签底至 icondian，不含上移补偿） */
export const CAR_LOG_CHECKIN_LINE_BASE_REM = 1.78

/** 打卡区1 竖线向下长度（rem） */
export const CAR_LOG_CHECKIN_LINE_INSIDE_LEFT_REM =
	CAR_LOG_CHECKIN_LINE_BASE_REM + CAR_LOG_CHECKIN_LABEL_RISE_REM

/** 打卡区2 竖线向下长度（rem） */
export const CAR_LOG_CHECKIN_LINE_INSIDE_RIGHT_REM =
	CAR_LOG_CHECKIN_LINE_BASE_REM + CAR_LOG_CHECKIN_LABEL_RISE_REM

/** 拉享好礼四指盖章核销规则（pointIndex=4） */
export const CAR_GIFT_CHECKIN_RULE_CODE = 'RULEffTe2oNP'

/** 拉享好礼核销回显 signlog.point */
export const CAR_GIFT_LEGACY_POINT = 'gift'

/** 拉享好礼盖章区默认锚点 */
export const CAR_GIFT_CHECKIN_ZONE_DEFAULT = {
	left: 50,
	top: 50,
	sizeWidth: 600,
	sizeHeight: 600
}

/** 拉享好礼中央状态图：待解锁 / 已解锁未核销 / 已核销 */
export const CAR_GIFT_STATUS_IMAGES = {
	locked: '/assets/car/icon/daka4-1.png',
	unlocked: '/assets/car/icon/daka4-2.png',
	redeemed: '/assets/car/icon/daka4-3.png'
}

export const CAR_LOG_CHECKIN_POINTS = [
	{
		itemClass: 'log_slide_item3',
		legacyPoint: 'one',
		ruleCode: 'RULEEES23JB',
		successClass: 'log_slide_item1',
		label: '打卡区1'
	},
	{
		itemClass: 'log_slide_item4',
		legacyPoint: 'three',
		ruleCode: 'RULEKKCnb37',
		successClass: 'log_slide_item2',
		label: '打卡区2'
	}
]
